import { Link } from '@vimeo/iris/typography';

import styles from './DesktopFooter.module.scss';
import footerLinks from '../../link.js';

const DesktopFooter = ({ className, Logo }) => {
  return (
    <div className={className}>
      <div className={styles.linkCol}>{Logo}</div>
      {footerLinks.map((el) => (
        <div className={styles.linkCol} key={el.category}>
          <div>{el.category}</div>
          {el.links.map((link) => (
            <Link
              variant="minimal"
              href={link.href}
              data-gtm-click={link.gtm}
              data-fatal-attraction={link.fa}
              key={link.text}
              className={styles.footerLink}
            >
              {link.text}
            </Link>
          ))}
        </div>
      ))}
    </div>
  );
};

export default DesktopFooter;
